import styled from "styled-components";
import colors from "../../../config/colors";

export const HorizontalLine = styled.hr`
  display: ${(props) => props.display || "flex"};
  width: ${(props) => props.width};
  height: ${(props) => props.height || "0.125rem"};
  background-color: ${(props) => props.color};
`;
